import "../../../../../../src/style/block.scss";
import "./style.scss";
import "../../../../../../src/style/buttons.scss";
import React, { useState } from "react";
import { Assort } from "../../../../models/Assort";
import { MdCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import { useTranslation } from "react-i18next";

interface IProps {
  exerciseGroups: Assort[];
  onSelect: (value: Assort) => void;
}
const SortModal: React.FC<IProps> = ({ exerciseGroups, onSelect }) => {
  const [open, setIndex] = useState(60);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="SortModal">
        {/* <button className="button small button-fill-background-main padding-small">{t("pokaz_wszystko")}</button> */}

        {exerciseGroups.map((item, index) => (
          <button
            key={index}
            onClick={() => {
              setIndex(index);
              onSelect(item);
            }}
            className="button small button-fill-background-main padding-small"
          >
            {index === open ? (
              <MdCheckBox className="icon no-transition" />
            ) : (
              <MdOutlineCheckBoxOutlineBlank className="icon no-transition" />
            )}

            {item.name}
          </button>
        ))}
      </div>
    </React.Fragment>
  );
};

export default SortModal;
